import fetch from '../utils/fetch';
import { companyURL } from 'endpoints';

function CompanyService() {
    const promiseCache = {};

    const cache = ( name, fn ) => {
        return async () => {
            if ( !promiseCache[ name ] ) {
                promiseCache[ name ] = fn();
            }
            return promiseCache[ name ];
        };
    };

    const listCompanies = cache( 'listCompanies', async () => {
        const res = await fetch( `${ companyURL }/graphql`, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(
                {
                    query: `
                        query companyListQuery {
                            companyList {
                                id
                                name
                                primaryLogo
                                primaryColor
                                secondaryColor
                            }
                        }
                    `,
                    variables: {}
                }
            )
        } );

        const { data, errors } = await res.json();
        if ( errors ) {
            throw new Error( errors.join( '\n' ) );
        }
        return data.companyList.sort(
            ( a, b ) => a.name.localeCompare( b.name, undefined, { 'sensitivity': 'base' } )
        );
    } );

    const getCompany = async ( companyId ) => {
        const companies = await listCompanies();
        return companies.find( c => c.id === companyId );
    };

    return {
        listCompanies,
        getCompany
    };
}

export default new CompanyService();
